import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('reportTagStore')
@observer
class FormModal extends Component {
  formRef = React.createRef()

  componentDidMount() {
    const {title, record} = this.props
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        'tagName': record?.tagName,
      })
    }
  }

  handleOk = () => {
    const {reportTagStore, handleCancel, title, record} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "id": title === 'edit' ? record?.id : null,
        "tagName": fieldsValue?.tagName,
      }
      reportTagStore.saveReportTag(params).then(res => {
        if (res?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }

  render() {
    const {addModalVisible, handleCancel, title, t} = this.props
    return (
      <>
        <Modal
          title={title === 'edit' ? t(`general.edit`) : t(`general.add`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addReportTag" layout="vertical">
            <Row gutter={[10, 10]}>
              <Col span={24}>
                <Form.Item name="tagName" label={t(`reportTag.tagName`)} rules={[{
                  required: true,
                  message: `${t(`general.pleaseEnter`)} ${t(`reportTag.tagName`)}`,
                }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)